import React from 'react'
import styled from 'styled-components'
import {IMAGE_ASSET} from 'consts/components'
import {Image} from 'common/components'
import {WINDOW_MODE_MOBILE_WIDTH} from 'consts/common'
import {AuthLoginForm} from '../LoginForm'
import {AuthLoginHeader} from '../LoginHeader'

const StyledLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: #b737e2e6;
  gap: 40px;

  @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
    justify-content: space-between;
    gap: initial;
  }
`

const StyledSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
    flex: 1;
    border-radius: 20px 20px 0px 0px;
  }
`

const StyledSectionForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  border-radius: 20px;
  background-color: ${({theme}) => theme.white_1};

  @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
    border-radius: 20px 20px 0px 0px;
    max-width: none;
  }
`

const StyledImage = styled(Image)`
  height: 100%;
  width: 100%;
`

export default function AuthLogin() {
  return (
    <>
      <StyledImage
        src={IMAGE_ASSET('giftshop', 'bg-dropbox.png')}
        alt="background"
      />
      <StyledLayoutContainer>
        <StyledSectionHeader>
          <AuthLoginHeader />
        </StyledSectionHeader>
        <StyledSectionForm>
          <AuthLoginForm />
        </StyledSectionForm>
      </StyledLayoutContainer>
    </>
  )
}
